/* global MatgenGlobal */

import {
  Form,
  TextInput,
  SelectInput,
  ButtonInput,
} from '../components/form/index.js';

const CognitoAgreementReportInputs = [
  new TextInput({
    type: 'date',
    label: 'Accepted From',
    id: 'inputAcceptedFrom',
    classes: 'top',
  }),
  new TextInput({
    type: 'date',
    label: 'Accepted To',
    id: 'inputAcceptedTo',
    classes: 'middle',
  }),
  new SelectInput({
    label: 'Tenant',
    id: 'inputTenantID',
    classes: 'bottom',
    options: async () => {
      const tenants = await MatgenGlobal.Data.getTenants();
      return [
        {
          label: 'All Tenants',
          value: '',
        },
        ...tenants.map(tenant => ({
          label: tenant.name,
          value: tenant.id,
        })),
      ];
    },
  }),
];

const CognitoAgreementReportButtons = [
  new ButtonInput({
    type: 'submit',
    label: 'Run Report',
    id: 'agreement-report-submit',
    classes: 'btn-lg btn-primary',
  }),
  new ButtonInput({
    type: 'button',
    label: 'Download CSV',
    id: 'agreement-report-download',
    classes: 'btn-lg btn-outline-primary',
  }),
];

const CognitoAgreementReportForm = new Form({
  inputs: CognitoAgreementReportInputs,
  buttons: CognitoAgreementReportButtons,
  id: 'cognito-agreement-report-form',
  title: 'Report filters',
});

export { CognitoAgreementReportForm };
